module.exports = __webpack_public_path__ + "static/bc523fc2-f152-43f7-b59b-bcf6f5109ba5-7694a518125d2213faf86b5d0faef4ec.webp";